import { render, staticRenderFns } from "./NoCourseNotification.vue?vue&type=template&id=92cb309e&scoped=true&"
import script from "./NoCourseNotification.vue?vue&type=script&lang=js&"
export * from "./NoCourseNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cb309e",
  null
  
)

export default component.exports